import React from 'react';

import { flagStyles } from '../settings';

const SvgLA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2976px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLA;
